<template>
  <div v-bind="$attrs" class="c-bitts-divider">
    <span v-if="text !== ''" :class="[backgroundColor, textColor]" class="px-8">
      {{ allCaps ? text.toUpperCase() : text }}
    </span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  allCaps?: boolean;
  backgroundColor?: string;
  text?: string;
  textColor?: string;
}

withDefaults(defineProps<Props>(), {
  allCaps: false,
  backgroundColor: 'bg-white',
  text: '',
  textColor: 'text-neutral-text-weak',
});
</script>

<style lang="pcss" scoped>
@reference "../../../../apps/crossbeam-app/src/css/theme.css";
.c-bitts-divider {
  @apply text-center my-10 mb-20 text-sm border-t border-neutral-border;
  line-height: 0.05rem !important;
}
</style>
